const regex = {
	lettersSpacesHyphens: /^[a-zA-ZăîșțâĂÎȘȚÂ -]+$/,
	lettersSpacesHyphensDigits: /^[a-zA-Z0-9ăîșțâĂÎȘȚÂ -]+$/,
	digits: /^\d*$/,
	phone: /^0\d{9}$/,
	codClient: /^\d{12}$/,
	companyName: /^[a-zA-Z0-9-&. ]*$/,
	companyCode: /^(RO|ro)?[1-9]\d{1,9}$/,
	companyCodeNumeric: /^[1-9]\d{1,9}$/,
	companyCodeChars: /^[roRO\d]*$/,
	gpsCoords: /^[-+]?([1-8]?\d(\.\d+)?|90(\.0+)?),\s*[-+]?(180(\.0+)?|((1[0-7]\d)|([1-9]?\d))(\.\d+)?)$/,
};

export default regex;
